const memberRouterList = [
  {
    name: 'memberIndex',
    path: '/member/index',
    meta: { title: '会员信息' },
    component: () =>
      import(/* webpackChunkName: "memberIndex" */ '../../pages/member/index'),
  },
  {
    name: 'memberPrivilege',
    path: '/member/privilege',
    meta: { title: '会员优惠' },
    component: () =>
      import(
        /* webpackChunkName: "memberPrivilege" */ '../../pages/member/privilege'
      ),
  },
  {
    name: 'memberDiscount',
    path: '/member/discount',
    meta: { title: '会员优惠' },
    component: () =>
      import(
        /* webpackChunkName: "memberDiscount" */ '../../pages/member/discount'
      ),
  },
  {
    name: 'frameRegister',
    path: '/member/frame-register',
    meta: { title: '会员注册' },
    component: () =>
      import(
        /* webpackChunkName: "frameRegister" */ '../../pages/member/frame-register'
      ),
  },
  {
    name: 'RedPacket',
    path: '/member/redPacket',
    meta: { title: '会员红包' },
    component: () =>
      import(
        /* webpackChunkName: "RedPacket" */ '../../pages/member/RedPacket'
      ),
  },
]
memberRouterList.forEach(item => {
  item.meta.isNotShare = true
})
export default memberRouterList
